import {FlyingBubble} from "js/Elements/BubbleFlyingBehaviour";
import {playSound} from "js/handlers/playSound";
import {GameGrid} from "js/Elements/GameGrid";
import { game } from '../main';
import {lengthDirX, lengthDirY} from "js/utils/lengthDir";
import {changeTexture} from "js/utils/changeTexture";
import {FlyingBombFx} from "js/Elements/FlyingBombFx";
import {isBomb} from "js/Elements/helpers";

export class ShooterFlyingBubble extends Phaser.Sprite implements FlyingBubble {
  onCollision = new Phaser.Signal();
  onWallBounce = new Phaser.Signal();

  private bombFx: FlyingBombFx | null = null;

  private grid: GameGrid;
    bubbleType: number = 0;
    collCircle: Phaser.Circle = new Phaser.Circle();
    vel = { x: 0, y: 0 };
    cell = { x: 0, y : 0 };
    prevCell= { x: 0, y : 0 };

    constructor(grid: GameGrid) {
      super(game, 0, 0);
      this.anchor.setTo(0.5);
      this.grid = grid;

      this.onWallBounce.add(() => {
        playSound('bubble_hits_wall');
      });
    }

    public init(x: number, y: number, type: number) {
      this.x = x;
      this.y = y;
      this.collCircle.diameter = 25;
      this.cell.x = -99999;
      this.cell.y = -99999;
      this.prevCell.x = 0;
      this.prevCell.y = 0;
      this.alpha = 1
      this.bubbleType = type;

      changeTexture(this, game.config.skinId + '_bubble_' + game.config.bubbleNames[type]);
      return this;
    }

    public setType(type: number) {
      this.bombFx = null;
      this.bubbleType = type;
      changeTexture(this, game.config.skinId + '_bubble_' + game.config.bubbleNames[type]);

      if (isBomb(type)) {
        this.bombFx = new FlyingBombFx(this);
      }
      return this;
    }

    public setShootAngle(angle: number) {
      const speed = 12;
      this.vel.x = lengthDirX(angle, speed, false);
      this.vel.y = lengthDirY(angle, speed, false);
      return this;
    }

    public update() {
      if (this.bombFx) {
        this.bombFx.update();
      }
    }
}
